module.exports = __webpack_public_path__ + "banner-in-preparation.png?a4de0a2a00a5f0ff7659377ef8f99fa9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-in-preparation.png
// module id = 575
// module chunks = 0